import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountPayersRoutes = [
  {
    path: 'payers',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Payers')
      },
      permissions: ['READ_PAYERS', 'READ_COMPANIES']
    },
    children: [
      {
        path: '',
        name: 'payersList',
        component: wrapLegacyRoute('payersController', 'list')
      },
      {
        path: ':payerId(\\d+)',
        name: 'payerDetails',
        component: wrapLegacyRoute('payersController', 'payerDetails')
      },
      {
        path: 'create',
        name: 'payerCreate',
        component: wrapLegacyRoute('payersController', 'create')
      },
      {
        path: ':payerId(\\d+)/versions',
        name: 'versionCreate',
        component: wrapLegacyRoute('payersController', 'payers')
      },
      {
        path: ':payerId(\\d+)/:versionId(\\d+)',
        name: 'payerVersionDetails',
        component: wrapLegacyRoute('payersController', 'payerVersionDetails')
      }
    ]
  }
];

export default accountPayersRoutes;
